import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  dataLayer: any = [];

  constructor(translate: TranslateService) {
    this.dataLayer.push({
      "pageLanguage": translate.currentLang
    });
  }
}
